import React, { Component } from "react";
import { BsyUtils } from "../../../utils/Utils";
import BsySearchResult from "../../BsySearchResult";
import "./index.css";

import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import BsySearchInput from "../../BsySearchInput";

const DragHandle = sortableHandle(() => <i className="icon-drag" />);

const SortableItem = sortableElement((props) => <>{props.children}</>);

const SortableContainer = sortableContainer(({ children }) => {
  return <div className={"custom-app"}>{children}</div>;
});
class BsyDashboardMyAppConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: props.apps || [],
      appMaps: {},
      customApps: [],
      maxEntrys: 12,
      key: "",
      seachList: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const items = { ...nextProps.customApp };
    this.setState({
      customApp: items,
    });
  }

  entryClick = (e) => {
    e.stopPropagation();
  };

  onSelectApp = (app, e, t) => {
    let { customApps } = this.state;
    if (!app) {
      return;
    }
    let customAppsList = [];
    customApps.map((appdata) => {
      customAppsList.push(appdata._id);
    });
    if (customAppsList.indexOf(app._id) < 0) {
      customApps.push(app);
      if (t === "search") {
        let i = document.createElement("i");
        i.classList.add("icon-ok");
        e.currentTarget.appendChild(i);
      }
    }
    this.setState({
      customApps,
    });
  };

  getSearchValue = (ref) => {
    this.searchValue = ref;
  };

  onSearch = () => {
    let key = this.searchValue.getValue();
    if (!key) {
      this.setState({
        key: "",
        seachList: [],
      });
      return;
    }
    React.axios("/dashboard/search", {
      keyword: key,
      type: "entry",
    })
      .then((res) => {
        this.setState({
          key: this.searchValue.getValue(),
          seachList: res.data.list,
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };
  findEntryS = (entry) => {
    const { customApps } = this.state;

    const s = customApps.filter((data, index) => {
      return data._id === entry._id;
    });
    return s.length > 0;
  };
  entryDel = (entry) => {
    const { customApps } = this.state;
    const s = customApps.filter((data, index) => {
      return data._id !== entry._id;
    });

    this.setState({
      customApps: s,
    });
  };

  entryAdd = (entry) => {
    const { customApps } = this.state;

    const s = [...customApps, entry];
    this.setState({
      customApps: s,
    });
  };

  renderApplist = () => {
    const { apps, customApps } = this.state;
    let that = this;
    let customAppsList = [];
    customApps.map((appdata) => {
      customAppsList.push(appdata._id);
      return null;
    });
    return (
      <>
        {apps.map((data, index) => {
          if (BsyUtils.isObjectEmpty(data.apps)) {
            return "";
          }
          return (
            <>
              <div className={"applist-group"} title={data.name} key={data._id}>
                {data.name}
              </div>
              {data.apps.map((appdata, appindex) => {
                return (
                  <div className={"applist-item "}>
                    <div
                      className="app-title"
                      key={appdata._id}
                      onClick={(e) => {
                        that.onSelectApp(appdata, e);
                      }}
                    >
                      <div
                        className={
                          "app-icon color-cover-" + appdata.style.color
                        }
                      >
                        <div
                          className={
                            "imgbg-bsy-app imgbg-bsy-app-" + appdata.style.icon
                          }
                        />
                      </div>
                      <span className="appname">{appdata.appname}</span>
                      {customAppsList.indexOf(appdata._id) > -1 && (
                        <i className="icon-ok" />
                      )}
                    </div>
                  </div>
                );
              })}
            </>
          );
        })}
      </>
    );
  };

  onSortEnd = (data, groupInfo) => {
    const { oldIndex, newIndex } = data;
    const { customApps } = this.state;
    const scr = arrayMoveImmutable(customApps, oldIndex, newIndex);

    this.setState({
      customApps: scr,
    });
  };

  getValue = () => {
    const { customApps } = this.state;
    return customApps;
  };

  renderSeachlist = () => {
    const { seachList, customApps } = this.state;
    let customAppsList = [];
    customApps.map((appdata) => {
      customAppsList.push(appdata._id);
    });
    return (
      <>
        {seachList.map((appdata, index) => {
          return (
            <div className={"applist-item "} key={appdata._id}>
              <div
                className="app-title"
                onClick={(e) => {
                  this.onSelectApp(appdata, e);
                }}
              >
                <div className={"app-icon color-cover-" + appdata.style.color}>
                  <div
                    className={
                      "imgbg-bsy-app imgbg-bsy-app-" + appdata.style.icon
                    }
                  />
                </div>
                <span className="appname">{appdata.appname}</span>
                {customAppsList.indexOf(appdata._id) > -1 && (
                  <i className="icon-ok" />
                )}
              </div>
            </div>
          );

          // <div className={'applist-item '} onClick={this.EntryClick} >
          //     <i className={'entry-icon ' + BsyUtils.getFormIcon({ ...data.style, type: data.type })} />
          //     <span className={'entry-title'}>{data.appname}</span>

          //     <span className={'right-entry-title'}>{
          //         this.findEntryS(data)
          //             ? <span className='read-tip'>{React.language('add.already')}</span>
          //             : <i className='icon-bsy-appAdd' onClick={e => { this.entryAdd(data) }} />
          //     }</span>
          // </div>
        })}
      </>
    );
  };

  getApplist = () => {
    const { apps } = this.state;
    let appList = [];
    apps.map((data, index) => {
      appList = [...appList, ...data.apps];
    });
    return appList;
  };

  render() {
    const { customApps, maxEntrys, key, entryList } = this.state;
    let customAppsList = [];
    customApps.map((appdata) => {
      customAppsList.push(appdata._id);
    });
    return (
      <div className="dashboard-custom-app-config">
        <div className={"left-app-list"}>
          <div className="applist-seach">
            <BsySearchInput
              styleInput={{
                width: "100%",
              }}
              placeholder={React.language("search.data")}
              onSearch={(e) => {
                // this.seachKey = e ? e.trim() : "";
                this.setState({
                  key: e ? e.trim() : "",
                  seachList: this.getApplist().filter((data) => {
                    return data.appname.indexOf(e) > -1;
                  }),
                });
              }}
              type={window.mode}
              // iconName="icon-bsy-reportmenu-0"
            ></BsySearchInput>
          </div>
          <div className="applist">
            {!key ? this.renderApplist() : this.renderSeachlist()}
          </div>
        </div>
        <div className={"right-custom-app"}>
          <div className="entrys-num">
            <span>
              {React.language("add.already.num", {
                num: customApps.length,
              })}
            </span>
          </div>
          {/* <div className='speedy-entrys'> */}
          <SortableContainer
            axis={"xy"}
            distance={10}
            useDragHandle={true}
            onSortEnd={(e) => {
              this.onSortEnd(e);
            }}
          >
            {customApps.map((data, index) => {
              return (
                <SortableItem key={`item-${index}`} index={index} value={data}>
                  <div
                    className={"applist-item applistDrag"}
                    onClick={this.EntryClick}
                  >
                    <div className="app-title">
                      <div
                        className={"app-icon color-cover-" + data.style.color}
                      >
                        <div
                          className={
                            "imgbg-bsy-app imgbg-bsy-app-" + data.style.icon
                          }
                        />
                      </div>
                      <span className="appname">{data.appname}</span>
                      <div className="entry-btn">
                        <span
                          className={"entry-del"}
                          onClick={(e) => {
                            this.entryDel(data);
                          }}
                        >
                          <i className="icon-remove" />
                        </span>
                        <span className={"entry-move"}>{<DragHandle />}</span>
                      </div>
                    </div>
                  </div>
                </SortableItem>
              );
            })}
          </SortableContainer>
          {/* </div> */}
        </div>
      </div>
    );
  }
}

export default BsyDashboardMyAppConfig;
